import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'adf-notifications',
	standalone: true,
	imports: [CommonModule, NgbTooltip],
	templateUrl: './notifications.component.html',
	styleUrl: './notifications.component.scss',
})
export class NotificationsComponent {}
